import http from "@/plugins/axios_plugin";

class ServiceAgendamentos {
  index(rodadaId, params) {
    return http.get("/api/agendamentos/" + rodadaId, { params: { ...params } });
  }

  salvar(rodadaId, agendamento) {
    return http.post("/api/agendamentos/" + rodadaId + "/salvar", agendamento);
  }

  excluir(agendamentoId) {
    return http.delete("/api/agendamentos/" + agendamentoId + "/excluir");
  }
}

export default new ServiceAgendamentos();
